export default function getBrowserWidth() {
    return window.innerWidth || document.body.clientWidth;
}
//# sourceMappingURL=getBrowserWidth.js.map